/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Customizable code area zoom",
  "description": "Choose custom settings for the minimum, maximum, speed, and start size of the zoom of scripts in the code area, and autohide the controls.",
  "tags": [],
  "credits": [
    {
      "name": "ErrorGamer2000",
      "link": "https://scratch.mit.edu/users/ErrorGamer2000/"
    }
  ],
  "enabledByDefault": false,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Maximum Zoom (50-500%)",
      "id": "maxZoom",
      "type": "integer",
      "min": 100,
      "default": 300,
      "max": 500
    },
    {
      "dynamic": true,
      "name": "Minimum Zoom (1-100%)",
      "id": "minZoom",
      "type": "integer",
      "min": 1,
      "default": 30,
      "max": 100
    },
    {
      "dynamic": true,
      "name": "Start Zoom (50-500%)",
      "id": "startZoom",
      "type": "integer",
      "min": 50,
      "default": 68,
      "max": 500
    },
    {
      "dynamic": true,
      "name": "Zoom Speed (50-200%)",
      "id": "zoomSpeed",
      "type": "integer",
      "min": 50,
      "default": 100,
      "max": 200
    },
    {
      "name": "Autohide Zoom Controls",
      "id": "autohide",
      "type": "boolean",
      "default": false
    },
    {
      "dynamic": true,
      "name": "Autohide Animation duration",
      "id": "speed",
      "type": "select",
      "potentialValues": [
        {
          "id": "none",
          "name": "None"
        },
        {
          "id": "short",
          "name": "Short"
        },
        {
          "id": "default",
          "name": "Default"
        },
        {
          "id": "long",
          "name": "Long"
        }
      ],
      "default": "default",
      "if": {
        "settings": {
          "autohide": true
        }
      }
    }
  ]
};
export default manifest;
